{
  "intent": "Are you looking to sell or rent your {{property}}?",
  "property_type": "What kind of property is it — apartment, villa, independent house, or something else?",
  "location": "Where's your {{property}}? A pincode or full address works best — locality and city are fine too if that's easier.",
  "location_city_in_state": "Which city in {{state}} is your {{property}} in?",
  "location_locality": "Which area or locality in {{city}}? If you know the pincode, add that too (e.g. Gachibowli, 500032).",
  "location_pincode_us": "What's the ZIP code for your {{property}} in {{city}}?",
  "location_map_pin": "Pin the exact location of your {{property}} on the map below so buyers can find it easily.",
  "location_full_address": "Please confirm the complete address details for your {{property}} (Building name, flat/unit, street, locality, pincode).",
  "bedrooms": "How many bedrooms — what's the BHK?",
  "bathrooms": "And how many bathrooms?",
  "furnishing": "Is it furnished, semi-furnished, or unfurnished?",
  "facing": "Which way does the {{property}} face?",
  "age_of_construction": "Roughly how old is the building?",
  "maintenance_charges": "What are the monthly maintenance charges? You can skip this if it doesn't apply.",
  "amenities": "What amenities does the place have? Pick whatever applies.",
  "price": "What price or rent are you expecting?",
  "parking_spaces": "How many parking spots come with it?",
  "nearby_places": "Anything good nearby — schools, hospitals, malls, parks?",
  "connectivity": "How's getting around — metro, buses, main roads?",
  "floor_number": "Which floor is the {{property}} on?",
  "area": "What's the total area in sqft?",
  "area_type": "Is that built-up, carpet, or super built-up area?",
  "lifts": "How many lifts does the building have?",
  "balconies": "How many balconies?",
  "title": "Want a title for your listing? Pick one that stands out.",
  "images": "Got photos or a video tour of the {{property}}? A few good shots or a short video really help — upload if you have them.",
  "documents": "Any documents to add — brochure, floor plan, legal papers? Totally optional.",
  "summary": "I've put together a summary on the right — take a look. Does everything look good? Reply yes to submit, or no if you'd like to change something.",
  "pg_name": "What's the name of your PG or hostel?",
  "available_for": "Who can stay here — boys, girls, or co-ed?",
  "pg_present_in": "Is the PG in its own building, inside a flat, or in a gated society?",
  "room_sharing": "What sharing options do you offer? Pick all that apply.",
  "pg_sharing_details": "Share the rent details for the sharing type you selected.",
  "pg_tenant_preference": "Any preference on who you'd like as tenants?",
  "pg_rules": "Any house rules? Pick what applies, or skip if there aren't specific ones.",
  "pg_gate_closing": "Is there a gate closing time tenants need to be back by?",
  "pg_food": "Is food available for tenants at your PG?",
  "pg_common_amenities": "What do tenants get in the common areas?",
  "pg_usp": "Anything that makes your PG stand out? Add a few highlights.",
  "pg_room_facilities": "What facilities come with the {{sharingLabel}} rooms?",
  "pg_available_from": "When can someone move in?",
  "security_deposit": "How much is the security deposit in INR? Put 0 if there's none.",
  "security_deposit_pg": "Security deposit per bed in INR? Use 0 if you don't take one.",
  "commercial_subtype": "What kind of commercial space is it?",
  "listing_subtype": "Which specific type is it?",
  "commercial_zone": "What's the zoning on the land?",
  "total_floors": "How many floors in the building?",
  "personal_washroom": "Does it have its own washroom?",
  "extra_pantry": "What about the pantry — dry, wet, or none?",
  "furnishing_status": "How's it furnished?",
  "ideal_for_businesses": "What kind of businesses would fit well here?",
  "washroom_available": "Is there a washroom on the premises?",
  "corner_shop": "Is it a corner shop?",
  "main_road_facing": "Does it face the main road?",
  "entrance_width": "How wide is the entrance, in feet?",
  "possession_status": "What's the possession status — ready to move, under construction?",
  "available_from": "When can someone move in or take possession?",
  "currently_leased_out": "Is it already rented out to someone?",
  "assured_returns": "Are you offering assured returns on this?",
  "booking_token_amount": "Any booking or token amount in INR?",
  "maintenance_frequency": "How often are maintenance charges due — monthly, quarterly?",
  "washroom_count": "How many washrooms?",
  "plot_length": "What's the plot length in feet?",
  "plot_breadth": "And the breadth in feet?",
  "nearby_businesses": "What businesses are around the plot?",
  "floors_allowed_for_construction": "How many floors can be built on it?",
  "open_sides": "How many open sides does the plot have?",
  "road_width_facing_plot": "What's the road width facing the plot, in feet?",
  "boundary_wall": "Is there a boundary wall already?",
  "corner_plot": "Corner plot?",
  "truck_accessibility": "Can trucks get in easily?",
  "loading_unloading_access": "Is there space for loading and unloading?",
  "road_width": "What's the road width in feet?",
  "ceiling_height": "What's the ceiling height in feet?",
  "power_supply": "What power supply does it have?",
  "parking_space": "How many parking spaces?",
  "_submit_ready": "You're all set — hit 'Publish' on the right when you're ready to publish your listing. 🎉",
  "_auto_publish": "Great! Submitting your property listing now... 🎉",
  "_resume_prefix": "Welcome back — let's pick up where you left off on your listing.",
  "_revision_prefix": "Sure, let's tweak that. ",
  "_revision_select": "Which parts would you like to update?",
  "location_set_success": "Location has been set to {{place}}.",
  "floor_number_pg": "Which floor is your PG on in the building?",
  "pg_sharing_details_rent": "What are the rent details for {{sharingLabel}} sharing?",
  "pg_sharing_details_sell": "How many {{sharingLabel}} rooms do you have available?",
  "locality_tier": "Which locality tier best describes this area?",
  "sale_type": "Is this a brand new property or a resale?",
  "ownership": "What is the ownership or legal title type for this property?",
  "rera": "Is this property RERA registered / approved?"
}
